import styled from 'styled-components'
import { MOBILE_HEADER_HEIGHT, SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

export const MusicTabContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 22px 16px 8px;
  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    min-height: 0;
    height: calc(100vh - ${MOBILE_HEADER_HEIGHT}px);
  }
`
